/**
 * Fleet Alliance Roster · Director directive 2026.06 · Strike #23
 *
 * Sister nodes in the Sovereign ecosystem. Outbound links carry UTM
 * parameters so each destination's analytics can attribute inbound
 * traffic to this hull (fleet-medium=alliance).
 *
 * To add a new alliance member: append to ALLIANCE_LINKS. The
 * <FleetAllianceRow /> component below auto-renders any new entries
 * in both the dedicated `/alliance` section AND the compliance footer.
 */

export const ALLIANCE_LINKS = [
    {
        slug: "island-gold",
        name: "Island Gold",
        tagline: "Flagship command bridge",
        url: "https://eigoo-command.preview.emergentagent.com/?utm_source=fleet&utm_medium=alliance&utm_campaign=flagship",
    },
    {
        slug: "siren-hub",
        name: "Siren Hub",
        tagline: "Sovereign storefront",
        url: "https://siren-storefront.preview.emergentagent.com/?utm_source=fleet&utm_medium=alliance&utm_campaign=siren",
    },
    {
        slug: "lead-sentry",
        name: "Lead Sentry",
        tagline: "Pipeline guardian",
        url: "https://lead-sentry-gold.preview.emergentagent.com/?utm_source=fleet&utm_medium=alliance&utm_campaign=leadsentry",
    },
];
